module.exports = __webpack_public_path__ + "00d6b3e5c335e3fbd1b4a774011b098b.svg";